






























































import { Component, Prop, Inject, Mixins } from "vue-property-decorator";
import {
  IAffiliateProvider,
  IAffiliateProviderMethods
} from "@/models/providers/affiliate";
import { IAccount } from "@/models/accounts";
import { IEmail } from "@/models/emails";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import _ from "@/boot/lodash";
import {
  IAffiliateTier,
  IAffiliatePayoutDestination
} from "@/models/affiliate";
import { IAffiliatePayoutDestinationsMethods } from "@/models/providers/affiliatePayoutDestinations";

interface IAffiliateAccountSettingsForm {
  affiliate_payout_destination_id?: IAffiliatePayoutDestination["id"] | null;
  affiliate_payout_paypal_email_id?: IEmail["id"] | null;
  affiliate_tier_id: IAffiliateTier["id"] | null;
}

@Component({
  components: {
    "client-email-select": () =>
      import("@/components/app/global/fields/clientEmailSelect.vue"),
    "affiliate-tier-select": () =>
      import(
        "@/components/app/admin/settings/affiliates/tiers/affiliateTierSelect.vue"
      ),
    "payout-destinations-provider": () =>
      import(
        "@/components/app/global/affiliate/payoutDestinationsProvider.vue"
      ),
    "payout-destination-select": () =>
      import("@/components/app/global/affiliate/payoutDestinationSelect.vue")
  }
})
export default class AffiliateAccountSettingsForm extends Mixins(Context) {
  @Inject({ from: "affiliateProvider" })
  public readonly $affiliateData!: () => IAffiliateProvider;

  @Inject({ from: "affiliateProviderMethods" })
  public readonly $affiliateMethods!: IAffiliateProviderMethods;

  @Inject({ from: "affiliatePayoutDestinationsProviderMethods" })
  public $affPDsMethods!: IAffiliatePayoutDestinationsMethods;

  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  // Data

  public form = {} as IAffiliateAccountSettingsForm;
  public isProcessing = false;

  // Computed

  public get affiliateData() {
    return this.$affiliateData();
  }

  public get brandId() {
    return this.affiliateData.affiliate?.account?.brand_id;
  }

  public get clientId() {
    return this.affiliateData.affiliate?.account?.clients?.[0].id;
  }

  public get isPayPal() {
    return this.$affPDsMethods.isPaypal(
      this.form.affiliate_payout_destination_id
    );
  }

  public get formIsValid() {
    if (_.isEqual(this.form, this.initForm())) return false;
    return true;
  }

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsValid;
  }

  // Life-cycle methods

  public created() {
    return this.setInitialState();
  }

  // Methods

  public async setInitialState() {
    this.form = this.initForm();
  }

  public initForm(): IAffiliateAccountSettingsForm {
    return {
      affiliate_payout_destination_id: this.affiliateData.affiliate?.account
        ?.affiliate_payout_destination_id,
      affiliate_payout_paypal_email_id: this.affiliateData.affiliate?.account
        ?.affiliate_payout_paypal_email_id,
      affiliate_tier_id:
        this.affiliateData.affiliate?.account?.affiliate_tier_id ?? null
    };
  }

  public doUpdate() {
    return this.$store.dispatch(`data/${DataModules.CLIENTS_ACCOUNTS}/update`, {
      accountId: this.accountId,
      data: this.form
    });
  }

  public async validateBeforeSubmit() {
    if (this.formIsDisabled) return;
    try {
      this.isProcessing = true;
      await this.doUpdate();
      await this.$affiliateMethods.reloadData();
      this.setInitialState();
      this.$emit("success");
      this.$buefy.toast.open({
        message: this.$t("_.account_updated") as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
